import React from "react";

import { cn } from "../../utils";
import { DropdownMenuTrigger as DropdownMenuTriggerUI } from "../dropdown-menu";

interface DropdownMenuTriggerProps {
  icon?: React.ReactNode;
  label?: string;
  className?: string;
  onTriggerClick?: () => void;
}

export const DropdownMenuTrigger = ({
  icon,
  label,
  className,
  onTriggerClick,
}: DropdownMenuTriggerProps) => (
  <DropdownMenuTriggerUI
    hideChevron
    size="sm"
    onPointerDown={e => {
      e.stopPropagation();
    }}
    onMouseDown={e => {
      e.stopPropagation();
    }}
    onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      onTriggerClick?.();
    }}
    className={cn("border-0 p-1 shadow-none group-hover:bg-gray-50", className)}
  >
    <span className="flex items-center">
      {icon}
      {label && <span className="ml-2">{label}</span>}
    </span>
  </DropdownMenuTriggerUI>
);
